import React, { useEffect, useState } from "react";
import { useTheme } from "../../../contexts/ThemeContext";
import { readableColor } from "polished";
import SwipeLeftIcon from '@mui/icons-material/SwipeLeft';
import SwipeRightIcon from '@mui/icons-material/SwipeRight';
import SwipeIcon from '@mui/icons-material/Swipe';

export const ProgressTable = ({ children, headers }) => {
  const theme = useTheme();
  const [contrastColor, setContrastColor] = React.useState("#fff");
  const [showSwipeIndicators, setShowSwipeIndicators] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (theme) {
      setContrastColor(readableColor(theme.mode === "dark" ? theme.colors.backgroundPendienteLight : theme.colors.backgroundPendienteDark));
    }
  }, [theme]);

  useEffect(() => {
    // Check if device is mobile
    const checkMobile = () => {
      const ua = navigator.userAgent;
      const iOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
      const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
      setIsMobile(iOS || isMobileDevice);
    };
    
    checkMobile();
    
    // Auto-hide indicators after 5 seconds
    if (isMobile) {
      const timer = setTimeout(() => {
        setShowSwipeIndicators(false);
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <div className="relative flex flex-col w-full h-full overflow-hidden bg-clip-border"
      style={{
        backgroundColor: theme.mode === "dark" ? theme.colors?.backgroundColorNotCurrentModule : theme.colors?.background_secondary?.backgroundColor,
        boxShadow: theme.styles?.box_temas?.backgroundColor,
      }}
    >
      {/* Swipe indicators - only shown on mobile */}
      {isMobile && showSwipeIndicators && (
        <>
          {/* Horizontal swipe indicator */}
          <div 
            className="absolute top-[2.2rem] left-0 right-0 flex justify-end px-4 z-10 pointer-events-none animate-pulse "
            style={{ transform: 'translateY(-50%)' }}
          >
            <SwipeIcon 
              sx={{ 
                fontSize: '3.8rem', 
                color:  '#fff',
                fill:  theme.mode === "dark" ? "#000" : "#fff",
                /* backgroundColor: 'rgba(255,255,255,0.7)', */
                borderRadius: '50%',
                padding: '4px',
                opacity: setTimeout(() => {
                  return 0;
                }, 5000),
               
              }} 
            />
          </div>
          
          {/* Hint text */}
         {/*  <div 
            className="absolute bottom-2 left-0 right-0 text-center pointer-events-none"
            style={{
              color: theme.colors.primary || '#000',
              backgroundColor: 'rgba(255,255,255,0.7)',
              padding: '4px 8px',
              borderRadius: '4px',
              margin: 'auto',
              width: 'fit-content',
              opacity: setTimeout(() => {
                return 0;
              }, 5000),
            }}
          >
            <p className="text-lg font-medium">Desliza para ver más</p>
          </div> */}
        </>
      )}

      {/* Table with shadow to indicate scrollability */}
      <div className="w-full h-full overflow-auto shadow-xl rounded-lg">
        <table className="w-full text-left table-auto min-w-max">
          <thead>
            <tr>
              {headers &&
                headers.map((h, idx) => {
                  return (
                    <th
                      className="p-4 border-b"
                      style={{
                        backgroundColor: theme.mode === "dark" ? theme.colors.backgroundPendienteLight : theme.colors.backgroundPendienteDark,
                        borderColor: `${theme.colors.backgroundColorNotCurrentModule}40`,
                      }}
                      key={idx}
                      scope="col"
                    >
                      <p
                        className="block text-md leading-none font-bold uppercase"
                        style={{
                          color: contrastColor,
                        }}
                      >
                        {h}
                      </p>
                    </th>
                  );
                })}
            </tr>
          </thead>
          <tbody>{children}</tbody>
        </table>
      </div>
    </div>
  );
};